import { IState } from '../store';
import { IVideoSchema } from '../types';

export const getPhotos = (state: IState) => {
  try {
    return state.villageData.village.gallery?.imageList ?? [];
  } catch {
    return [];
  }
};

const checkVideo = (url: string) =>
  // tslint:disable-next-line:max-line-length
  /^http(s)?:\/\/(www.)?(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})$/i.test(
    url,
  );

export const isYoutubeVideo = ({ url = '' }: IVideoSchema) => checkVideo(url);

export const getVideos = (state: IState) => {
  try {
    return state.villageData.village.videoList?.filter(isYoutubeVideo) ?? [];
  } catch {
    return [];
  }
};
